import { fetchTransactionInformation } from 'components/FXTransactions/func';
import useAuth from 'hooks/useAuth';
import useStore from 'hooks/useStore';
import { useState } from 'react';
import styled from 'styled-components';
import NoResult from '../NoResult';
import NoTransaction from '../NoTransaction';
import TransactionItem from './components/TransactionItem';

import OuterFitHeight from 'components/common/CollapsibleSideMenu/OuterFitHeight';
import Endpoint from 'components/common/Endpoint';
import FormTransactionDetails from 'components/fx/components/FormTransactionDetails';
import { FX_TRANSACTION_ADD_PREFIX, FX_TRANSACTIONS_PREFIX } from 'constants';
import Cookies from 'helpers/cookies';
import { FX_MAKE_PAYMENT_KEY } from 'hooks/fx/useFxAddTransaction';
import useFxFormAddTransactionStore from 'hooks/fx/useFxFormAddTransactionStore';
import useBodyContentStatus from 'hooks/useBodyContentStatus';
import useCommonStore from 'hooks/useCommonStore';
import useNotify from 'hooks/useNotify';
import { isEmpty } from 'lodash';
import { useNavigate } from 'react-router-dom';
import { domUtils } from 'utils';

const TransactionList = ({
  transactions,
  setTransactions,
  searchValue,
  applyFiltered,
  currentSearchBy,
  currentPage,
  setCurrentPage,
  setTotalElements,
  setTotalPages,
  isFetching,
  setFetching,
  sortOrder,
}) => {
  const { dispatch } = useStore();
  const { token } = useAuth();
  const navigate = useNavigate();

  const [information, setInformation] = useState(null);

  let { isBodyContentNoResult, isBodyContentEmpty, isBodyContentBlank } =
    useBodyContentStatus({
      isFetching,
      list: transactions,
      sorts: sortOrder,
      filters: applyFiltered,
      search: searchValue,
    });

  const { resetDataFlowHandler } = useNotify();

  const { transactionDetails, setTransactionDetails } =
    useFxFormAddTransactionStore();
  const { setLoading } = useCommonStore();

  const handleOnCloseTransactionDetailsPopup = () => {
    setTransactionDetails(null);

    domUtils.changeAddressBarUrlWithoutReloadPage({
      prefix: FX_TRANSACTIONS_PREFIX,
    });

    resetDataFlowHandler();
  };
  const handleOnOpenTransactionDetailsPopup = async (transaction) => {
    if (isEmpty(transaction)) return;

    const { orderRef, orderStatus } = transaction || {};
    setLoading(true);
    const transactionDetails = await fetchTransactionInformation(
      token,
      orderRef,
      orderStatus,
    );
    setTransactionDetails(transactionDetails);
    setLoading(false);
  };
  const handleOnMakePayment = () => {
    if (isEmpty(transactionDetails)) return;
    resetDataFlowHandler();
    const { orderRef } = transactionDetails;
    navigate(`${FX_TRANSACTION_ADD_PREFIX}?orderRef=${orderRef}`);
    Cookies.set(FX_MAKE_PAYMENT_KEY, true);
  };

  if (isBodyContentNoResult) {
    return (
      <OuterFitHeight isCenter maxHeight="50dvh">
        <NoResult />
      </OuterFitHeight>
    );
  }
  if (isBodyContentEmpty) {
    return (
      <OuterFitHeight isCenter maxHeight="50dvh">
        <NoTransaction />
      </OuterFitHeight>
    );
  }
  if (isBodyContentBlank) {
    return null;
  }
  return (
    <>
      {!isEmpty(transactionDetails) && (
        <FormTransactionDetails
          isOpen={!isEmpty(transactionDetails)}
          onClose={handleOnCloseTransactionDetailsPopup}
          onClick={handleOnMakePayment}
        />
      )}

      <TransactionListStyled>
        {transactions?.map((tran) => (
          <TransactionItem
            key={tran?.orderRef}
            transaction={tran}
            onClick={() => handleOnOpenTransactionDetailsPopup(tran)}
          />
        ))}
        <Endpoint />
      </TransactionListStyled>
    </>
  );
};

const TransactionListStyled = styled.div`
  width: 100%;
  height: fit-content;
`;

export default TransactionList;
